import PropTypes from 'prop-types';
import React from 'react';


export default function Arrows({ showLeftArrow, showRightArrow, handleLeftArrowClick, handleRightArrowClick, showReloadAtEnd }) {
  function getEndClass() {
    if (showReloadAtEnd) return 'hundredicons-refresh';
    return 'hundredicons-arrow-right-filled -is-hidden';
  }

  return (
    <div className="carrousel__arrow-container">
      <span
        className={ `carrousel__arrow-left hundredicons-arrow-left-filled ${showLeftArrow ? '-is-showed' : '-is-hidden'}` }
        id="carrousel-arrow-left"
        onClick={ showLeftArrow ? handleLeftArrowClick : e => e.preventDefault() }
      />
      <span
        className={ `carrousel__arrow-right ${showRightArrow ? 'hundredicons-arrow-right-filled' : getEndClass()} ` }
        id="carrousel-arrow-right"
        onClick={ showRightArrow || showReloadAtEnd ? handleRightArrowClick : e => e.preventDefault() }
      />
    </div>
  );
}

Arrows.defaultProps = {
  showReloadAtEnd: true,
};

Arrows.propTypes = {
  handleLeftArrowClick: PropTypes.func.isRequired,
  handleRightArrowClick: PropTypes.func.isRequired,
  showLeftArrow: PropTypes.bool.isRequired,
  showReloadAtEnd: PropTypes.bool,
  showRightArrow: PropTypes.bool.isRequired,
};
